export const defaultMatakuliah = [
	{
		id: 'f3333a6c-e739-4039-9be0-3ed06c28aed5',
		nama: 'Etika Profesi',
		semester: 7,
		sks: 2,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 8
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696032,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'b21fcfb6-028c-4e66-8838-d50e667482b4',
		nama: 'Gerbang Logika Terprogram',
		semester: 5,
		sks: 3,
		nilai: {
			indeks: 'B',
			bobot: 3,
			akhir: 9
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696048,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '14443651-1c0c-4143-b591-bccbd362b072',
		nama: 'Jaringan Komputer',
		semester: 3,
		sks: 4,
		nilai: {
			indeks: 'B',
			bobot: 3,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696056,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'b6993d1f-7dbe-4578-b308-37399692b53e',
		nama: 'Keamanan Komputer',
		semester: 3,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696064,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '6531b7a9-e260-4a49-90c0-44b16b2add67',
		nama: 'Kewirausahaan',
		semester: 2,
		sks: 2,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 8
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696072,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '84684e05-a397-4e28-925d-3fdef6a44c62',
		nama: 'Komputasi Citra Digital',
		semester: 4,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696080,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'b37c15e3-cf4d-4372-931f-1e942bb1d306',
		nama: 'Matematika Komputasi',
		semester: 7,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696096,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'e18df55f-079b-4ef5-8c4f-71760bcd0c4f',
		nama: 'Matematika Komputasi Lanjut',
		semester: 5,
		sks: 4,
		nilai: {
			indeks: 'B',
			bobot: 3,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696104,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '66c14754-c52b-4702-b828-408b236272c7',
		nama: 'Metode Numerik',
		semester: 8,
		sks: 3,
		nilai: {
			indeks: 'B+',
			bobot: 3.5,
			akhir: 10.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696113,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '46a8b683-c253-4f75-be55-a466dddf6488',
		nama: 'Metodologi Penelitian dan Penulisan Ilmiah',
		semester: 7,
		sks: 3,
		nilai: {
			indeks: 'D+',
			bobot: 1.5,
			akhir: 4.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696121,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'd91031bc-746c-406f-a744-046fee5a8c44',
		nama: 'Pancasila',
		semester: 3,
		sks: 2,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 8
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696129,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'c872e89a-63ab-4383-b61e-13964cdef39e',
		nama: 'Pemrograman Dasar',
		semester: 1,
		sks: 5,
		nilai: {
			indeks: 'B',
			bobot: 3,
			akhir: 15
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'B',
			bobot: 3
		},
		created_at: 1723696137,
		updated_at: 1725350257,
		deleted_at: null
	},
	{
		id: 'c586ce67-b2ff-46ac-942f-89c683eef49a',
		nama: 'Pemrograman Lanjut',
		semester: 1,
		sks: 5,
		nilai: {
			indeks: 'C+',
			bobot: 2.5,
			akhir: 12.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'C+',
			bobot: 2.5
		},
		created_at: 1723696145,
		updated_at: 1725350295,
		deleted_at: null
	},
	{
		id: '53a8ccf0-6651-4fd3-b0a2-da67e67d3a9a',
		nama: 'Pemrosesan Sinyal',
		semester: 4,
		sks: 3,
		nilai: {
			indeks: 'B+',
			bobot: 3.5,
			akhir: 10.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696153,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'd2be1dac-f318-45cd-be94-8bdc5850d52a',
		nama: 'Pemrosesan Suara',
		semester: 8,
		sks: 3,
		nilai: {
			indeks: 'B+',
			bobot: 3.5,
			akhir: 10.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696161,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'af123916-4a96-461b-9333-8030c2a283c8',
		nama: 'Pendidikan Agama Islam',
		semester: 6,
		sks: 2,
		nilai: {
			indeks: 'B',
			bobot: 3,
			akhir: 6
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696169,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '2657539f-6663-400b-ae91-efed1159b811',
		nama: 'Pendidikan Kewarganegaraan',
		semester: 7,
		sks: 2,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 8
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696177,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'd407b9e7-33c6-45a9-a41d-66459455e58d',
		nama: 'Pengantar Ilmu Komputer',
		semester: 6,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696185,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '111174a6-2fec-4dd5-a33c-2f156c85040b',
		nama: 'Perangkat Bergerak',
		semester: 1,
		sks: 2,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 8
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696193,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'a965ea2e-c4d3-4be6-bbe1-03f8631b8a05',
		nama: 'Praktik Kerja Lapangan',
		semester: 8,
		sks: 4,
		nilai: {
			indeks: 'B+',
			bobot: 3.5,
			akhir: 14
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696201,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'f1f3c6af-6855-4813-aec3-e396e8d9b2d8',
		nama: 'Rangkaian dan Elektronika',
		semester: 3,
		sks: 3,
		nilai: {
			indeks: 'C+',
			bobot: 2.5,
			akhir: 7.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696213,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '680d00ec-0d5f-47d8-8226-f2c921c6b46a',
		nama: 'Rangkaian dan Elektronika Lanjut',
		semester: 8,
		sks: 4,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 16
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696221,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'b45aaa44-2edf-48e1-a11b-711761743693',
		nama: 'Rekayasa Sistem Komputer',
		semester: 1,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696229,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '1588de9f-dcd5-4240-a89f-0736b52863cc',
		nama: 'Sensor dan Aktuator',
		semester: 2,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696237,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '7c2468a8-9ba1-46fa-8235-1eaf9239f62d',
		nama: 'Sistem Cerdas',
		semester: 8,
		sks: 3,
		nilai: {
			indeks: 'B+',
			bobot: 3.5,
			akhir: 10.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696245,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'b25a71e1-6d2d-4c7a-89b7-be35f84cf5ac',
		nama: 'Sistem Digital',
		semester: 5,
		sks: 4,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 16
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696253,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '2c5594a3-c598-433a-b769-c0066f7d182f',
		nama: 'Sistem Kendali',
		semester: 6,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696261,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '480b7d7f-5d5a-4573-b605-f4c03500497b',
		nama: 'Sistem Linier',
		semester: 5,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696277,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '42d7d50e-59aa-4fd2-83b2-9e87a2a52301',
		nama: 'Sistem Medis Berbasis Komputer',
		semester: 5,
		sks: 3,
		nilai: {
			indeks: 'B+',
			bobot: 3.5,
			akhir: 10.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696285,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'c701d4d2-a3ef-4ac2-9592-d08ee021dc46',
		nama: 'Sistem Mikrokontroller',
		semester: 6,
		sks: 4,
		nilai: {
			indeks: 'B+',
			bobot: 3.5,
			akhir: 14
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696293,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '3b698857-db9d-4b5f-a6bc-7a125d85494f',
		nama: 'Sistem Operasi',
		semester: 8,
		sks: 4,
		nilai: {
			indeks: 'C+',
			bobot: 2.5,
			akhir: 10
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696301,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '10427f7b-d78a-4b2d-8bac-438e3d80ce79',
		nama: 'Sistem Pengenalan Pola',
		semester: 8,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696309,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '27fb96d9-dace-4ad9-8485-8ebc823badf6',
		nama: 'Statistika',
		semester: 3,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1723696317,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '2391b986-7663-4079-bcb6-0a6dbad4d702',
		nama: 'Administrasi Jaringan',
		semester: 2,
		sks: 3,
		nilai: {
			indeks: 'C',
			bobot: 2,
			akhir: 6
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'D+',
			bobot: 1.5
		},
		created_at: 1724992926,
		updated_at: 1725350361,
		deleted_at: null
	},
	{
		id: '545477f6-b72b-4c05-ac80-df2b6659c05e',
		nama: 'Algoritma dan Struktur Data',
		semester: 2,
		sks: 4,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 16
		},
		dapat_diulang: false,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1725072654,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '20ba8487-5fae-4805-8e37-0b040cd4340e',
		nama: 'Analisis Sistem Komputer dan Jaringan',
		semester: 6,
		sks: 3,
		nilai: {
			indeks: 'B',
			bobot: 3,
			akhir: 9
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1725073929,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'd965bd8f-156b-4bec-8056-b399d0d24f89',
		nama: 'Arsitektur dan Organisasi Komputer',
		semester: 2,
		sks: 3,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1725074018,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'f65923e2-e3e6-4d33-b2f9-8104df45b52e',
		nama: 'Arsitektur dan Organisasi Komputer Lanjut',
		semester: 6,
		sks: 4,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 16
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1725074098,
		updated_at: 1725074110,
		deleted_at: null
	},
	{
		id: 'ed02fd1c-9d2a-457a-a71a-ecaa393cbf52',
		nama: 'Bahasa Indonesia',
		semester: 8,
		sks: 2,
		nilai: {
			indeks: 'A',
			bobot: 4,
			akhir: 8
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1725135363,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '7978128a-d7fe-4931-af08-1b796d97d6f0',
		nama: 'Bahasa Inggris',
		semester: 2,
		sks: 2,
		nilai: {
			indeks: 'B+',
			bobot: 3.5,
			akhir: 7
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1725135480,
		updated_at: 1726067337,
		deleted_at: null
	},
	{
		id: '6d8f2f4b-ac53-4dfa-a60f-17171d8d5fef',
		nama: 'Basis Data Terapan',
		semester: 6,
		sks: 3,
		nilai: {
			indeks: 'C+',
			bobot: 2.5,
			akhir: 7.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1726054167,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'd3da0e24-5675-45b0-a272-2c6c1642cea9',
		nama: 'Komunikasi Data',
		semester: 6,
		sks: 3,
		nilai: {
			indeks: 'B',
			bobot: 3,
			akhir: 9
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1726326844,
		updated_at: null,
		deleted_at: null
	},
	{
		id: 'c86de07b-8790-401e-bef8-b8fc7c089f21',
		nama: 'Embedded System',
		semester: 7,
		sks: 4,
		nilai: {
			indeks: 'B',
			bobot: 3,
			akhir: 12
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'A',
			bobot: 4
		},
		created_at: 1730598280,
		updated_at: null,
		deleted_at: null
	},
	{
		id: '5fbd3551-9b02-43ba-811f-af6cda382fec',
		nama: 'Wireless Sensor Network',
		semester: 1,
		sks: 3,
		nilai: {
			indeks: 'B+',
			bobot: 3.5,
			akhir: 10.5
		},
		dapat_diulang: true,
		owned_by: 'e2b6a96a-c9c6-4cb8-a8c1-8ec27fc0c12c',
		target_nilai: {
			indeks: 'B',
			bobot: 3
		},
		created_at: 1730598450,
		updated_at: null,
		deleted_at: null
	}
];

export const defaultPenilaian = {
	A: {
		cat: 'Sangat baik',
		style: 'success',
		weight: 4
	},
	'B+': {
		cat: 'Antara sangat baik dan baik',
		style: 'success',
		weight: 3.5
	},
	B: {
		cat: 'Baik',
		style: 'warning',
		weight: 3
	},
	'C+': {
		cat: 'Antara baik dan cukup',
		style: 'warning',
		weight: 2.5
	},
	C: {
		cat: 'Cukup',
		style: 'danger',
		weight: 2
	},
	'D+': {
		cat: 'Antara cukup dan kurang',
		style: 'danger',
		weight: 1.5
	},
	D: {
		cat: 'Kurang',
		style: 'crimson',
		weight: 1
	},
	E: {
		cat: 'Sangat kurang',
		style: 'crimson',
		weight: 0
	}
};
